import styled from 'styled-components'

import { Avatar } from '@/components/avatar'

export type TestimonialProps = {
  darkMode?: boolean
}

export const TestimonialContainer = styled.div<TestimonialProps>`
  display: flex;
  flex-direction: row;
  align-items: center;

  gap: 24px;

  .testimonial-text {
    color: ${({ darkMode, theme }) =>
      darkMode ? theme.colors.white : theme.colors.black};
  }
`

export const AuthorContainer = styled.div`
  .author-role {
    margin-top: 7px;
    font-size: 16px;
    line-height: 19.5px;
  }
  .author-name {
    font-size: 20px;
    line-height: 24.38px;
  }

  @media (max-width: 700px) {
    display: flex;
    flex-direction: row;
    gap: 7px;

    .author-role {
      font-size: 16px;
    }
  }
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 700px) {
    .case-description {
      font-size: 12px;
    }
  }
`

export const AvatarSide = styled(Avatar)`
  @media (max-width: 700px) {
    display: none;
  }
`

export const AvatarTop = styled(Avatar)`
  display: none;

  @media (max-width: 700px) {
    width: 50px;
    height: 50px;
    display: block;
  }
`
